
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/suburb-properties",
      function () {
        return require("private-next-pages/suburb-properties.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/suburb-properties"])
      });
    }
  